import { render, staticRenderFns } from "./OrganizerPage.vue?vue&type=template&id=45f9e708&scoped=true&"
import script from "./OrganizerPage.vue?vue&type=script&lang=js&"
export * from "./OrganizerPage.vue?vue&type=script&lang=js&"
import style0 from "./OrganizerPage.vue?vue&type=style&index=0&id=45f9e708&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f9e708",
  null
  
)

export default component.exports